// extracted by mini-css-extract-plugin
export default {"container":"DangerCard_container__ppHxW","header":"DangerCard_header__Pvgfc"};